module.exports = __webpack_public_path__ + "img/sub_manual_m.545b94a1.png";